import { ListItem, ListItemText } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { PortMapItem } from "../types/mapItems";

const useStyles = makeStyles((theme) => ({
  divider: {
    borderBottomColor: theme.palette.primary.light,
  },
}));

interface Props {
  port: PortMapItem;
  style: React.CSSProperties;
  onClick: (p: PortMapItem) => void;
}

const PortListItem = ({ port, style, onClick }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <ListItem
      button
      divider
      classes={{ divider: classes.divider }}
      style={style}
      onClick={() => onClick(port)}
    >
      <ListItemText
        primary={port.name}
        primaryTypographyProps={{ noWrap: true, title: port.name }}
        secondaryTypographyProps={{
          color: "inherit",
          noWrap: true,
          title: port.description,
        }}
        secondary={port.description}
      />
    </ListItem>
  );
};

export default PortListItem;
